/**
 * Convert string into path case.
 * Join punctuation with space.
 * @memberof module:stringcase/lib
 * @function spacecase
 * @param {string} str - String to convert.
 * @returns {string} Path cased string.
 */
'use strict';

var snakecase = require('./snakecase');
/** @lends spacecase */


function spacecase(str) {
  return snakecase(str).replace(/_/g, ' ');
}

module.exports = spacecase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNwYWNlY2FzZS5qcyJdLCJuYW1lcyI6WyJzbmFrZWNhc2UiLCJyZXF1aXJlIiwic3BhY2VjYXNlIiwic3RyIiwicmVwbGFjZSIsIm1vZHVsZSIsImV4cG9ydHMiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OztBQVNBOztBQUVBLElBQU1BLFNBQVMsR0FBR0MsT0FBTyxDQUFDLGFBQUQsQ0FBekI7QUFFQTs7O0FBQ0EsU0FBU0MsU0FBVCxDQUFvQkMsR0FBcEIsRUFBeUI7QUFDdkIsU0FBT0gsU0FBUyxDQUFDRyxHQUFELENBQVQsQ0FBZUMsT0FBZixDQUF1QixJQUF2QixFQUE2QixHQUE3QixDQUFQO0FBQ0Q7O0FBRURDLE1BQU0sQ0FBQ0MsT0FBUCxHQUFpQkosU0FBakIiLCJzb3VyY2VSb290IjoiLi4vLi4vbGliIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb252ZXJ0IHN0cmluZyBpbnRvIHBhdGggY2FzZS5cbiAqIEpvaW4gcHVuY3R1YXRpb24gd2l0aCBzcGFjZS5cbiAqIEBtZW1iZXJvZiBtb2R1bGU6c3RyaW5nY2FzZS9saWJcbiAqIEBmdW5jdGlvbiBzcGFjZWNhc2VcbiAqIEBwYXJhbSB7c3RyaW5nfSBzdHIgLSBTdHJpbmcgdG8gY29udmVydC5cbiAqIEByZXR1cm5zIHtzdHJpbmd9IFBhdGggY2FzZWQgc3RyaW5nLlxuICovXG5cbid1c2Ugc3RyaWN0J1xuXG5jb25zdCBzbmFrZWNhc2UgPSByZXF1aXJlKCcuL3NuYWtlY2FzZScpXG5cbi8qKiBAbGVuZHMgc3BhY2VjYXNlICovXG5mdW5jdGlvbiBzcGFjZWNhc2UgKHN0cikge1xuICByZXR1cm4gc25ha2VjYXNlKHN0cikucmVwbGFjZSgvXy9nLCAnICcpXG59XG5cbm1vZHVsZS5leHBvcnRzID0gc3BhY2VjYXNlO1xuIl19